import firebase from "firebase";
import firestore from "firebase/firestore";

var config = {
  apiKey: "AIzaSyDGCZf9Pt3oeORJ_dBCQE1fvqfqtMZNyDo",
  authDomain: "zebrastripes-697fb.firebaseapp.com",
  databaseURL: "https://zebrastripes-697fb.firebaseio.com",
  projectId: "zebrastripes-697fb",
  storageBucket: "zebrastripes-697fb.appspot.com",
  messagingSenderId: "762386377282"
};

firebase.initializeApp(config);
let db = firebase.firestore();
export default db;



// WEBPACK FOOTER //
// ./src/firebaseConfig.js